import { SWR_KEYS } from '@bulknutrients/bulk-shared-lib/constants';

import { isErrorResponse } from '@bulknutrients/bulk-shared-lib/interfaces/BulkAPI';
import type {
  DigitalItem,
  PhysicalItem,
} from '@bulknutrients/bulk-shared-lib/interfaces/ICart';
import type {
  OptionSelections,
  UpdateCartItemAPIResponse,
} from 'pages/api/cart';
import { useSWRConfig } from 'swr';

export function useUpdateItem({
  lineItem,
  include,
}: {
  lineItem: PhysicalItem | DigitalItem;
  include?: string[];
}) {
  const { mutate } = useSWRConfig();

  return async ({
    productId,
    variantId,
    quantity = 1,
    optionSelections,
  }: {
    productId?: number;
    variantId?: number;
    quantity?: number;
    optionSelections?: OptionSelections[];
  }) => {
    const res = await fetch('/api/cart', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        lineItem,
        item: {
          productId,
          variantId,
          quantity,
          optionSelections,
        },
        include,
      }),
    });

    const response: UpdateCartItemAPIResponse = await res.json();
    if (isErrorResponse(response)) {
      return {
        error: response.error.message.join('. '),
      };
    }

    mutate(SWR_KEYS.cart);

    return {
      data: null,
    };
  };
}
